export default __webpack_public_path__ + "static/tv-screen-mask-bc2eb7c3a4c925758734c80f086e2bcf.svg";